export default __webpack_public_path__ + "static/media/google-analytics.795b7cc8.svg";